// auth types
export const CREATE_USER = "CREATE_USER";
export const LOGIN = "LOGIN";
export const LOG_OUT = "LOG_OUT";
export const GET_USERS = "GET_USERS";
export const GET_USER = "GET_USER";

export const RESET_LOADING = "RESET_LOADING";
export const SET_LOADING = "SET_LOADING";
export const RESET = "RESET";
export const CLEAR = "CLEAR";
export const SET_ERROR = "SET_ERROR";





export const SET_NEW_PASSWORD = "SET_NEW_PASSWORD";
export const SEND_LOGIN_OTP = "SEND_LOGIN_OTP";
export const VERIFY_LOGIN_OTP = "VERIFY_ADMIN_LOGIN_OTP";
export const RESET_PASSWORD = "RESET_PASSWORD";
export const FORGET_PASSWORD = "FORGET_PASSWORD";
export const VERIFY_AND_SET_PASSWORD = "VERIFY_AND_SET_PASSWORD";
export const CONTACT_FORM = "CONTACT_FORM";



export const GET_MY_STATEMENT = "GET_MY_STATEMENT";
export const PRINT_MY_STATEMENT = "PRINT_MY_STATEMENT";
export const SET_STATEMENT_LOADING = "SET_STATEMENT_LOADING";
export const RESET_STATEMENT = "RESET_STATEMENT";




export const GET_MY_ACCOUNTS = "GET_MY_ACCOUNTS";
